// Ignore intentional dynamic keys
const i18nIgnoredKeys = [
    'insightDescriptionI18nKey',
    'verificationModalBodyI18nKey',
    'verificationModalTitleI18nKey',
    'trendsAdminMessageI18nKey',
    'trendsNonAdminMessageI18nKey',
    'deleteModalKeyPath',
];

export const DEFAULT_LOCALE = 'en';

export const SUPPORTED_LOCALES = ['en', 'ja', 'de', 'pt-BR', 'es'];

export const UNANNOUNCED_LOCALES = ['fr-FR'];

export default {
    localePath: 'modules/appengine/client/modules/pendo-app/utils/i18n/locales',
    outputPath: './modules/appengine/client/modules/pendo-app/locales',
    srcPath: './modules/appengine/client/modules/pendo-app',
    dependentLocalePaths: [
        'node_modules/@pendo/components/lib/es/locales',
        'node_modules/@pendo/login/dist/es/locales',
        'node_modules/@pendo/one-ui-shared/dist/es/locales',
        'node_modules/@pendo/tagging/dist/locales',
    ],
    check: {
        ignore: {
            files: [], // Files to skip when checking for new $t strings; allows glob pattern
            keys: i18nIgnoredKeys, // Strings or context paths to skip when checking for new $t strings
        },
    },
};